// Single source of truth for the C2C sidebar. UserMenu + AdminMenu used to be two
// hand-maintained copies that drifted; this is the one list they collapse into.
// Gating per group OR per item:
//   admin: true    → only shown to role === 'admin'
//   ot: true       → only shown when the session is ot_licensed
//   provider: true → only shown to provider staff (session.is_provider); use for
//                    fleet-wide config a client admin must not see (global Settings)
// A top-level { type: 'link' } is a flat link (Home/Dashboard); everything else is
// a { type: 'group' } with children. Rendered by Menu.js (active state comes from
// the URL, so screens no longer need to pass a matching currentMenu).
const MENU = [
	{ type: 'link', label: 'Home', to: '/', icon: 'icon-home' },
	{ type: 'link', label: 'Dashboard', to: '/dashboard', icon: 'icon-dashboard' },

	{ type: 'group', label: 'Traffic', icon: 'icon-traffic', items: [
		{ label: 'Network Traffic', to: '/network-traffic' },
		{ label: 'Live Traffic', to: '/live-traffic' },
		{ label: 'Weekly Traffic', to: '/weekly-traffic' },
		{ label: 'Device Vendors', to: '/device-vendors' },
	] },

	{ type: 'group', label: 'Threats & Security', icon: 'icon-lock', items: [
		{ label: 'Network Alerts', to: '/network-alerts' },
		{ label: 'Appliance Security', to: '/appliance-security' },
		{ label: 'File Transfers', to: '/file-transfers' },
		{ label: 'SOC Analytics', to: '/soc-analytics', admin: true },
		{ label: 'External Baseline', to: '/external-baseline-comms', admin: true },
		{ label: 'MorningWatch', to: '/morningwatch', admin: true },
	] },

	{ type: 'group', label: 'IDS', icon: 'icon-warning', items: [
		{ label: 'View Rules', to: '/ids-rules' },
		{ label: 'Import Rules', to: '/import-ids', admin: true },
	] },

	{ type: 'group', label: 'Watchers', icon: 'icon-eye', items: [
		{ label: 'Watcher Data', to: '/watcher-data' },
		{ label: 'Watcher Assets', to: '/watcher-assets' },
		{ label: 'Asset Baseline', to: '/asset-baseline' },
		{ label: 'Watcher Status', to: '/watcher-status' },
	] },

	{ type: 'group', label: 'Lists & Policy', icon: 'icon-settings', items: [
		{ label: 'Denied Lists', to: '/denied-lists' },
		{ label: 'IOC Lists', to: '/ioc-lists', admin: true },
		{ label: 'Blocking', to: '/blocking' },
		{ label: 'Network Zones', to: '/net-zones' },
		{ label: 'Import Zones', to: '/net-zones/import' },
		{ label: 'Switch CAM', to: '/switch-cam' },
		{ label: 'Import CAM', to: '/switch-cam/import' },
	] },

	{ type: 'group', label: 'OT', icon: 'icon-settings', ot: true, items: [
		{ label: 'BacNET', to: '/bacnet' },
		{ label: 'DNP3', to: '/dnp3' },
		{ label: 'Modbus', to: '/modbus' },
		{ label: 'S7 Comms', to: '/s7-comms' },
		{ label: 'OT Settings', to: '/ot-settings', admin: true },
	] },

	{ type: 'group', label: 'Reports', icon: 'icon-system', items: [
		{ label: 'Security Reports', to: '/security-reports' },
		{ label: 'Annual Report', to: '/annual-report' },
		{ label: 'PCAP Viewer', to: '/pcap-viewer', admin: true },
	] },

	{ type: 'group', label: 'Admin', icon: 'icon-system', admin: true, items: [
		{ label: 'Settings', to: '/watcher-settings', provider: true },
		{ label: 'Users', to: '/users' },
		{ label: 'Register Watcher', to: '/watchers' },
		{ label: 'Companies', to: '/companies' },
		{ label: 'Audit Log', to: '/audit-log' },
		{ label: 'System Updates', to: '/system-updates' },
		{ label: 'Device', to: '/device' },
	] },

	{ type: 'group', label: 'Help', icon: 'icon-help', items: [
		{ label: 'Documentation', to: '/docs/', external: true },
	] },
];

export default MENU;
